function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#851910"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.76609 14.3984C6.10552 13.7381 6.60302 13.1381 7.2302 12.6326C7.85738 12.1272 8.60195 11.7263 9.4214 11.4528C10.2408 11.1792 11.1191 11.0384 12.0061 11.0384C12.8931 11.0384 13.7713 11.1792 14.5908 11.4528C15.4102 11.7263 16.1548 12.1272 16.782 12.6326C17.4092 13.1381 17.9067 13.7381 18.2461 14.3984",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4306 4.09697L15.6214 4.66867",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.15603 4.68353L10.3392 4.08324",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.754 5.18184C17.754 5.18184 19.1013 5.79268 19.5122 6.81594C19.6909 7.26111 19.4111 7.79228 18.8867 8.00293C18.3617 8.21347 17.7922 8.0233 17.6134 7.57812C17.4145 7.08264 17.754 5.18184 17.754 5.18184Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19.6759 8.0627C19.6759 8.0627 21.0232 8.67354 21.434 9.6968C21.6128 10.142 21.333 10.6731 20.8086 10.8838C20.2836 11.0943 19.7141 10.9042 19.5353 10.459C19.3364 9.9635 19.6759 8.0627 19.6759 8.0627Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M6.40618 5.18184C6.40618 5.18184 5.05881 5.79268 4.648 6.81594C4.46927 7.26111 4.74907 7.79228 5.27342 8.00293C5.79842 8.21347 6.36798 8.0233 6.54671 7.57812C6.74563 7.08264 6.40618 5.18184 6.40618 5.18184Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M4.4843 8.0627C4.4843 8.0627 3.13693 8.67354 2.72612 9.6968C2.5474 10.142 2.8272 10.6731 3.35155 10.8838C3.87655 11.0943 4.44611 10.9042 4.62483 10.459C4.82375 9.9635 4.4843 8.0627 4.4843 8.0627Z",
  fill: "black"
});

var Svg10UnableToMove = function Svg10UnableToMove(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg10UnableToMove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/10_Unable_to_move.b275141f.svg";
export { ForwardRef as ReactComponent };